var jsonHighlight = {
  formatJson (data) {
    if(!data) {
      return ''
    }

    let json = JSON.stringify(data, null, 2)

    json = json.replace(/&/g, '&amp;')
               .replace(/</g, '&lt;')
               .replace(/>/g, '&gt;')

    return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)/g, (match) => {
      let cls = 'reports-json-number'

      if(/^"/.test(match)) {
        cls = /:$/.test(match) ? 'reports-json-key' : 'reports-json-string'
      } else if(/true|false/.test(match)) {
        cls = 'reports-json-boolean'
      } else if(/null/.test(match)) {
        cls = 'reports-json-null'
      }

      return '<span class="' + cls + '">' + match + '</span>'
    })
  },
}

export default jsonHighlight
